import React, { FC, useEffect } from 'react';
import { useFormik } from 'formik';
import {
	getValidationDetailsSchema,
	initialValidationValues, VALIDATION_FORM_FIELD,
	ValidationType
} from '../../../../constants/sense-js/sense-js-validation-form';
import { LinkComponent } from '../../../LinkComponent';
import { useTranslation } from 'react-i18next';
import { VerificationURLForm } from './VerificationURLForm';
import { VerificationLoading } from './VerificationLoading';
import { checkWidgetValidation } from '../../../../store/merchnts/actions/sites';
import { useMerchants } from '../../../../store/merchnts/merchants-context';
import { REQUEST_RESULT } from '../SenseJS';

export const senseJsModalFooter = ({ t }): JSX.Element => (
	<>
		<div className="block-separator my-5"/>
		<div className="pb-6">
				<span className="me-1">
					Need help installing Flex?
				</span>
			<LinkComponent text={t('CONFIRM_APP.MODAL_TITLE')} link='mailto:support@flex-charge.com'/>
		</div>
	</>
);

interface Props {
	siteId: string;
	mid: string;
	closeModal: () => void;
	responseModal: (value?: REQUEST_RESULT ) => void;
	setSiteName: (value: string) => void;
}

export const SenseJsVerificationModal: FC<Props> = (props) => {
	const { t } = useTranslation();
	const { siteId, closeModal, setSiteName, responseModal, mid } = props;
	const { merchantState: { isSenseJSValidationLoading }, dispatch } = useMerchants();
	const formik = useFormik<ValidationType>({
		initialValues: initialValidationValues,
		validationSchema: getValidationDetailsSchema,
		onSubmit: () => checkWidgetValidation(dispatch, formik, mid, siteId, closeModal, responseModal)
	});

	useEffect(() => {
		setSiteName(formik.getFieldProps(VALIDATION_FORM_FIELD.URL).value);
	}, [formik.getFieldProps(VALIDATION_FORM_FIELD.URL).value]);
	return (
		<div className="px-8">
			<div className="d-flex justify-content-end mb-5 fs-8">
				Site ID:
				<span className="fw-bolder ms-1">{siteId}</span>
			</div>

			{
				isSenseJSValidationLoading
					? <VerificationLoading/>
					: <VerificationURLForm formik={formik}/>
			}

			{senseJsModalFooter({ t })}
		</div>
	);
};
